<script>
import AppTimelineDefault from '@/components/ui/AppTimeline.vue'
import AppTimelineYokohama from '@/components/ui/uiYokohama/AppTimelineYokohama.vue'
import AppTimelineOsaka from '@/components/ui/uiOsaka/AppTimelineOsaka.vue'
import AppTimelineToda from '@/components/ui/uiToda/AppTimelineToda.vue'

import { injectFromLocation } from '@/helpers/Provider.js'
const component = injectFromLocation(AppTimelineDefault, [
  AppTimelineYokohama,
  AppTimelineOsaka,
  AppTimelineToda,
])

export default {
  extends: component,
  name: 'TimelineProvider.vue',
  setup() {
    return {
      ...component.setup(),
    }
  },
}
</script>
